import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MediaBrowserComponent } from './media-browser.component';
import { VideoJsModule } from '@schoolbelle/shared/directives';
import { GalleryModule } from '../gallery-core/index';
import 'hammerjs';
import { FacesModule } from './faces/faces.module';

@NgModule({
  imports: [
    CommonModule,
    VideoJsModule,
    GalleryModule,
    FacesModule,
  ],
  declarations: [MediaBrowserComponent],
  exports:[
    MediaBrowserComponent, 
    CommonModule,
    VideoJsModule,
    GalleryModule,
  ],
})
export class MediaBrowserModule { }